module.exports = __webpack_public_path__ + "img/gish_bus_altan.fdfc6c93.svg";